import { Grid } from '@material-ui/core';
import { EntityLayout } from '@backstage/plugin-catalog'
import { EntityOwnershipCard, EntityUserProfileCard } from '@backstage/plugin-org';
import { defaultEntityWarningContent } from './EntityWarningContent'

export type UserPageProps = {
  additionalCard?: React.JSX.Element;
  additionalRoute?: React.JSX.Element;
  entityWarningContent?: React.JSX.Element;
};
export const userPage = (props?: UserPageProps) => {

  return (
    <EntityLayout>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3}>
          {props?.entityWarningContent ?? defaultEntityWarningContent}
          <Grid item xs={12} md={6}>
            <EntityUserProfileCard />
          </Grid>
          <Grid item xs={12} md={6}>
            <EntityOwnershipCard />
          </Grid>
          {props?.additionalCard}
        </Grid>
      </EntityLayout.Route>
      {props?.additionalRoute}
    </EntityLayout>
  )
};
